<template>
  <div class="zip-code-inputs">
    <input required type="tel" ref="digit1" name="digit1" v-model="digit1" value=""
           class="input-coupon-text input-zipcode" maxlength="1" autofocus
           v-on:keyup.right="gotoRight(1)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <input required type="tel" ref="digit2" name="digit2" v-model="digit2" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(2)" v-on:keyup.left="gotoLeft(2)" v-on:keyup.right="gotoRight(2)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <input required type="tel" ref="digit3" name="digit3" v-model="digit3" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(3)" v-on:keyup.left="gotoLeft(3)" v-on:keyup.right="gotoRight(3)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <span>-</span>
    <input required type="tel" ref="digit4" name="digit4" v-model="digit4" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(4)" v-on:keyup.left="gotoLeft(4)" v-on:keyup.right="gotoRight(4)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <input required type="tel" ref="digit5" name="digit5" v-model="digit5" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(5)" v-on:keyup.left="gotoLeft(5)" v-on:keyup.right="gotoRight(5)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <input required type="tel" ref="digit6" name="digit6" v-model="digit6" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(6)" v-on:keyup.left="gotoLeft(6)" v-on:keyup.right="gotoRight(6)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
    <input required type="tel" ref="digit7" name="digit7" v-model="digit7" value=""
           class="input-coupon-text input-zipcode" maxlength="1"
           v-on:keydown.delete="deleteDigit(7)" v-on:keyup.left="gotoLeft(7)"
           v-on:keyup.enter="$emit('search-by-zipcode')">
  </div>
</template>

<script>
  export default {
    name: "ZipCodeInput",
    props: {},
    methods: {
      mergeDigits() {
        this.message = [1,2,3,4,5,6,7].reduce((prev, cur) => {
          return prev + this[`digit${cur}`]
        }, '')

        this.$emit('update-zip-code', this.message)
      },
      deleteDigit(current) {
        if (this[`digit${current}`] === '') {
          this.$refs[`digit${current - 1}`].focus()
        } else {
          this[`digit${current}`] = ''
        }

        this.mergeDigits()
      },
      gotoLeft(current) {
        this.$refs[`digit${current - 1}`].focus()
      },
      gotoRight(current) {
        this.$refs[`digit${current + 1}`].focus()
      },
    },
    watch: {
      digit1: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit1.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit2.focus()
        }else{
          this.digit1 = ''
        }
      },
      digit2: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit2.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit3.focus()
        }else{
          this.digit2 = ''
        }
      },
      digit3: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit3.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit4.focus()
        }else{
          this.digit3 = ''
        }
      },
      digit4: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit4.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit5.focus()
        }else{
          this.digit4 = ''
        }
      },
      digit5: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit5.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit6.focus()
        }else{
          this.digit5 = ''
        }
      },
      digit6: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit6.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$refs.digit7.focus()
        }else{
          this.digit6 = ''
        }
      },
      digit7: function(newValue,oldValue) {
        if (oldValue !== '') {
          this.$refs.digit7.focus()
        }
        if(this.regex.test(newValue)) {
          this.mergeDigits()
          this.$emit('update-zip-code', this.message)
        }else{
          // DO NOTHING
        }
      },
    },
    data () {
      return {
        message: '',
        digit1:'',
        digit2:'',
        digit3:'',
        digit4:'',
        digit5:'',
        digit6:'',
        digit7:'',
        regex: /[0-9]/,
        request_uuid : this.request_id,
        processing: false,
      }
    },
    mounted() {
      this.$refs.digit1.focus()
    }
  }
</script>

<style scoped>
  .zip-code-inputs {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .input-zipcode {
    width: 35px;
    height: 50px;
    margin-left: 2px;
    margin-right: 2px;
    font-family: SharpSansBold, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 24px;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
    border-width: 1px;
  }

  @media screen and (max-width: 60em) {
    .input-zipcode {
      width: 33px;
      margin-right: 2px;
      margin-left: 2px;
    }
  }
  @media screen and (max-width: 50em) {
    .input-zipcode {
      width: 30px;
    }
  }
  @media screen and (max-width: 20em) {
    .input-zipcode {
      width: 24.5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/ZipcodeInput.vue